import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { clearable: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_money = _resolveDirective("money")!

  return _withDirectives((_openBlock(), _createElementBlock("input", _hoisted_1, null, 512)), [
    [_directive_money, _ctx.CurrencyValueMask]
  ])
}